import { environment } from "@/aws-exports";
import { Report, UpdateReportParam } from "@/types/entities";
import axios from "axios";

const ENDPOOINT = environment.API.endpoints[0].endpoint;

function getErrorMessage(err: any) {
  if (!err || !err.response) {
    return "Unexpected Error";
  }
  console.log(`getErrorMessage: ${err.response}`);
  if (err.response.data) {
    const { message } = err.response.data;
    return message ? message : err.response.data;
  } else {
    return "Unexpected Error";
  }
}

// Customer 情報の取得
function getCustomer() {
  return new Promise( async (resolve, reject) => {
    try {
      const response = await axios.get(`${ENDPOOINT}/customer`);
      console.log(response);
      if (response.status === 200) {
        resolve(response.data);
      } else {
        console.log(response);
        reject(response.data);
      }
    } catch (err) {
      reject(getErrorMessage(err));
    }
  });
}

// Invoices 情報の取得
function getInvoices(year: string) {
  return new Promise( async (resolve, reject) => {
    try {
      const response = await axios.get(`${ENDPOOINT}/invoice`, {
        params: { year },
      });
      console.log(response);
      if (response.status === 200) {
        resolve(response.data.data);
      } else {
        console.log(response);
        reject(response.data);
      }
    } catch (err) {
      reject(getErrorMessage(err));
    }
  });
}

function updateSubscription(newCardToken: string) {
  return new Promise( async (resolve, reject) => {
    try {
      const response = await axios.put(`${ENDPOOINT}/subscription`, {
        stripeToken: newCardToken,
      });
      console.log(response);
      if (response.status === 200) {
        resolve(response.data);
      } else {
        console.log(response);
        reject(response.data);
      }
    } catch (err) {
      reject(getErrorMessage(err));
    }
  });
}

const contract = {
  getCustomer,
  getInvoices,
  updateSubscription,
};

export default contract;
